/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminCheck200,
  AdminLeague,
  AdminListAllMatchesParams,
  AdminListClubsParams,
  AdminMatch,
  AdminPendingScheduledMatch,
  AdminStats,
  CallupDetail,
  CallupInput,
  CallupSignup,
  CallupSummary,
  Club,
  CreateClubInput,
  CreateGlobalMatchInput,
  CreateLeagueMatchInput,
  CreateMatchResult,
  DeleteAccountInput,
  ExpoPushRegistration,
  ExpoPushRegistrationResult,
  ExtendedAdminStats,
  GetNationalRankingParams,
  GetNationalRankingStatsParams,
  HealthStatus,
  League,
  LeagueDetail,
  ListClubsParams,
  ListLeagueCallupsParams,
  MergeClubInput,
  MessageResult,
  NationalRankingPagedResponse,
  NationalRankingStats,
  PendingLeagueMatch,
  SuccessResult,
  UpdateCallupInput,
  UpdateClubInput,
  UpdateLeagueInput
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getRegisterExpoPushTokenUrl = () => {




  return `/api/push/expo/register`
}

export const registerExpoPushToken = async (expoPushRegistration: ExpoPushRegistration, options?: RequestInit): Promise<ExpoPushRegistrationResult> => {

  return customFetch<ExpoPushRegistrationResult>(getRegisterExpoPushTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(expoPushRegistration)
  }
);}





export const getRegisterExpoPushTokenMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerExpoPushToken>>, TError,{data: BodyType<ExpoPushRegistration>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerExpoPushToken>>, TError,{data: BodyType<ExpoPushRegistration>}, TContext> => {

const mutationKey = ['registerExpoPushToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerExpoPushToken>>, {data: BodyType<ExpoPushRegistration>}> = (props) => {
          const {data} = props ?? {};

          return  registerExpoPushToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterExpoPushTokenMutationResult = NonNullable<Awaited<ReturnType<typeof registerExpoPushToken>>>
    export type RegisterExpoPushTokenMutationBody = BodyType<ExpoPushRegistration>
    export type RegisterExpoPushTokenMutationError = ErrorType<void>

    export const useRegisterExpoPushToken = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerExpoPushToken>>, TError,{data: BodyType<ExpoPushRegistration>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerExpoPushToken>>,
        TError,
        {data: BodyType<ExpoPushRegistration>},
        TContext
      > => {
      return useMutation(getRegisterExpoPushTokenMutationOptions(options));
    }

export const getCreateLeagueMatchUrl = (leagueId: string,) => {




  return `/api/leagues/${leagueId}/matches`
}

/**
 * Creates a match in PENDING status. When the reporter is an admin who
 * did not participate in the match (`reporterTeam === 0`), `summary.winner`
 * is `null` and `summary.isUserParticipant` is `false`.
 * @summary Record a league match (participants or league admin)
 */
export const createLeagueMatch = async (leagueId: string,
    createLeagueMatchInput: CreateLeagueMatchInput, options?: RequestInit): Promise<CreateMatchResult> => {

  return customFetch<CreateMatchResult>(getCreateLeagueMatchUrl(leagueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLeagueMatchInput)
  }
);}





export const getCreateLeagueMatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeagueMatch>>, TError,{leagueId: string;data: BodyType<CreateLeagueMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLeagueMatch>>, TError,{leagueId: string;data: BodyType<CreateLeagueMatchInput>}, TContext> => {

const mutationKey = ['createLeagueMatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLeagueMatch>>, {leagueId: string;data: BodyType<CreateLeagueMatchInput>}> = (props) => {
          const {leagueId,data} = props ?? {};

          return  createLeagueMatch(leagueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeagueMatchMutationResult = NonNullable<Awaited<ReturnType<typeof createLeagueMatch>>>
    export type CreateLeagueMatchMutationBody = BodyType<CreateLeagueMatchInput>
    export type CreateLeagueMatchMutationError = ErrorType<void>

    /**
 * @summary Record a league match (participants or league admin)
 */
export const useCreateLeagueMatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeagueMatch>>, TError,{leagueId: string;data: BodyType<CreateLeagueMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLeagueMatch>>,
        TError,
        {leagueId: string;data: BodyType<CreateLeagueMatchInput>},
        TContext
      > => {
      return useMutation(getCreateLeagueMatchMutationOptions(options));
    }

export const getCreateGlobalMatchUrl = () => {




  return `/api/matches/global`
}

/**
 * The current user is always team 1 player 1 (always a participant).
 * `summary.winner` is never `null` and `summary.isUserParticipant` is
 * always `true` for this endpoint.
 * @summary Record a global (free-play) match
 */
export const createGlobalMatch = async (createGlobalMatchInput: CreateGlobalMatchInput, options?: RequestInit): Promise<CreateMatchResult> => {

  return customFetch<CreateMatchResult>(getCreateGlobalMatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createGlobalMatchInput)
  }
);}





export const getCreateGlobalMatchMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGlobalMatch>>, TError,{data: BodyType<CreateGlobalMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGlobalMatch>>, TError,{data: BodyType<CreateGlobalMatchInput>}, TContext> => {

const mutationKey = ['createGlobalMatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGlobalMatch>>, {data: BodyType<CreateGlobalMatchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createGlobalMatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGlobalMatchMutationResult = NonNullable<Awaited<ReturnType<typeof createGlobalMatch>>>
    export type CreateGlobalMatchMutationBody = BodyType<CreateGlobalMatchInput>
    export type CreateGlobalMatchMutationError = ErrorType<void>

    /**
 * @summary Record a global (free-play) match
 */
export const useCreateGlobalMatch = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGlobalMatch>>, TError,{data: BodyType<CreateGlobalMatchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createGlobalMatch>>,
        TError,
        {data: BodyType<CreateGlobalMatchInput>},
        TContext
      > => {
      return useMutation(getCreateGlobalMatchMutationOptions(options));
    }

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListClubsUrl = (params: ListClubsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/clubs?${stringifiedParams}` : `/api/clubs`
}

/**
 * @summary List clubs by country
 */
export const listClubs = async (params: ListClubsParams, options?: RequestInit): Promise<Club[]> => {

  return customFetch<Club[]>(getListClubsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClubsQueryKey = (params?: ListClubsParams,) => {
    return [
    `/api/clubs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListClubsQueryOptions = <TData = Awaited<ReturnType<typeof listClubs>>, TError = ErrorType<unknown>>(params: ListClubsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClubs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClubsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClubs>>> = ({ signal }) => listClubs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClubs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClubsQueryResult = NonNullable<Awaited<ReturnType<typeof listClubs>>>
export type ListClubsQueryError = ErrorType<unknown>


/**
 * @summary List clubs by country
 */

export function useListClubs<TData = Awaited<ReturnType<typeof listClubs>>, TError = ErrorType<unknown>>(
 params: ListClubsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClubs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClubsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateClubUrl = () => {




  return `/api/clubs`
}

/**
 * @summary Suggest a new club (any authenticated user)
 */
export const createClub = async (createClubInput: CreateClubInput, options?: RequestInit): Promise<Club> => {

  return customFetch<Club>(getCreateClubUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createClubInput)
  }
);}





export const getCreateClubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClub>>, TError,{data: BodyType<CreateClubInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createClub>>, TError,{data: BodyType<CreateClubInput>}, TContext> => {

const mutationKey = ['createClub'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClub>>, {data: BodyType<CreateClubInput>}> = (props) => {
          const {data} = props ?? {};

          return  createClub(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClubMutationResult = NonNullable<Awaited<ReturnType<typeof createClub>>>
    export type CreateClubMutationBody = BodyType<CreateClubInput>
    export type CreateClubMutationError = ErrorType<unknown>

    /**
 * @summary Suggest a new club (any authenticated user)
 */
export const useCreateClub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClub>>, TError,{data: BodyType<CreateClubInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createClub>>,
        TError,
        {data: BodyType<CreateClubInput>},
        TContext
      > => {
      return useMutation(getCreateClubMutationOptions(options));
    }

export const getGetLeagueDetailUrl = (id: string,) => {




  return `/api/leagues/${id}`
}

/**
 * @summary Get a league with members, matches, scheduled matches and the caller's membership
 */
export const getLeagueDetail = async (id: string, options?: RequestInit): Promise<LeagueDetail> => {

  return customFetch<LeagueDetail>(getGetLeagueDetailUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeagueDetailQueryKey = (id: string,) => {
    return [
    `/api/leagues/${id}`
    ] as const;
    }


export const getGetLeagueDetailQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueDetail>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLeagueDetail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueDetailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueDetail>>> = ({ signal }) => getLeagueDetail(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLeagueDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueDetail>>>
export type GetLeagueDetailQueryError = ErrorType<unknown>


/**
 * @summary Get a league with members, matches, scheduled matches and the caller's membership
 */

export function useGetLeagueDetail<TData = Awaited<ReturnType<typeof getLeagueDetail>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLeagueDetail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLeagueDetailQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLeagueUrl = (id: string,) => {




  return `/api/leagues/${id}`
}

/**
 * @summary Update a league (owner/admin only)
 */
export const updateLeague = async (id: string,
    updateLeagueInput: UpdateLeagueInput, options?: RequestInit): Promise<League> => {

  return customFetch<League>(getUpdateLeagueUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateLeagueInput)
  }
);}





export const getUpdateLeagueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeague>>, TError,{id: string;data: BodyType<UpdateLeagueInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLeague>>, TError,{id: string;data: BodyType<UpdateLeagueInput>}, TContext> => {

const mutationKey = ['updateLeague'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLeague>>, {id: string;data: BodyType<UpdateLeagueInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLeague(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeagueMutationResult = NonNullable<Awaited<ReturnType<typeof updateLeague>>>
    export type UpdateLeagueMutationBody = BodyType<UpdateLeagueInput>
    export type UpdateLeagueMutationError = ErrorType<unknown>

    /**
 * @summary Update a league (owner/admin only)
 */
export const useUpdateLeague = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeague>>, TError,{id: string;data: BodyType<UpdateLeagueInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLeague>>,
        TError,
        {id: string;data: BodyType<UpdateLeagueInput>},
        TContext
      > => {
      return useMutation(getUpdateLeagueMutationOptions(options));
    }

export const getListLeagueCallupsUrl = (leagueId: string,
    params?: ListLeagueCallupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leagues/${leagueId}/callups?${stringifiedParams}` : `/api/leagues/${leagueId}/callups`
}

/**
 * @summary List all callups for a league (members only)
 */
export const listLeagueCallups = async (leagueId: string,
    params?: ListLeagueCallupsParams, options?: RequestInit): Promise<CallupSummary[]> => {

  return customFetch<CallupSummary[]>(getListLeagueCallupsUrl(leagueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeagueCallupsQueryKey = (leagueId: string,
    params?: ListLeagueCallupsParams,) => {
    return [
    `/api/leagues/${leagueId}/callups`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLeagueCallupsQueryOptions = <TData = Awaited<ReturnType<typeof listLeagueCallups>>, TError = ErrorType<void>>(leagueId: string,
    params?: ListLeagueCallupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeagueCallups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeagueCallupsQueryKey(leagueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeagueCallups>>> = ({ signal }) => listLeagueCallups(leagueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: leagueId !== null && leagueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeagueCallups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLeagueCallupsQueryResult = NonNullable<Awaited<ReturnType<typeof listLeagueCallups>>>
export type ListLeagueCallupsQueryError = ErrorType<void>


/**
 * @summary List all callups for a league (members only)
 */

export function useListLeagueCallups<TData = Awaited<ReturnType<typeof listLeagueCallups>>, TError = ErrorType<void>>(
 leagueId: string,
    params?: ListLeagueCallupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLeagueCallups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLeagueCallupsQueryOptions(leagueId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCallupUrl = (leagueId: string,) => {




  return `/api/leagues/${leagueId}/callups`
}

/**
 * @summary Create a callup (admin/owner only)
 */
export const createCallup = async (leagueId: string,
    callupInput: CallupInput, options?: RequestInit): Promise<CallupSummary> => {

  return customFetch<CallupSummary>(getCreateCallupUrl(leagueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(callupInput)
  }
);}





export const getCreateCallupMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCallup>>, TError,{leagueId: string;data: BodyType<CallupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCallup>>, TError,{leagueId: string;data: BodyType<CallupInput>}, TContext> => {

const mutationKey = ['createCallup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCallup>>, {leagueId: string;data: BodyType<CallupInput>}> = (props) => {
          const {leagueId,data} = props ?? {};

          return  createCallup(leagueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCallupMutationResult = NonNullable<Awaited<ReturnType<typeof createCallup>>>
    export type CreateCallupMutationBody = BodyType<CallupInput>
    export type CreateCallupMutationError = ErrorType<void>

    /**
 * @summary Create a callup (admin/owner only)
 */
export const useCreateCallup = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCallup>>, TError,{leagueId: string;data: BodyType<CallupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCallup>>,
        TError,
        {leagueId: string;data: BodyType<CallupInput>},
        TContext
      > => {
      return useMutation(getCreateCallupMutationOptions(options));
    }

export const getGetCallupUrl = (leagueId: string,
    callupId: string,) => {




  return `/api/leagues/${leagueId}/callups/${callupId}`
}

/**
 * @summary Get a callup with its signups (members only)
 */
export const getCallup = async (leagueId: string,
    callupId: string, options?: RequestInit): Promise<CallupDetail> => {

  return customFetch<CallupDetail>(getGetCallupUrl(leagueId,callupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCallupQueryKey = (leagueId: string,
    callupId: string,) => {
    return [
    `/api/leagues/${leagueId}/callups/${callupId}`
    ] as const;
    }


export const getGetCallupQueryOptions = <TData = Awaited<ReturnType<typeof getCallup>>, TError = ErrorType<void>>(leagueId: string,
    callupId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCallup>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCallupQueryKey(leagueId,callupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallup>>> = ({ signal }) => getCallup(leagueId,callupId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: leagueId !== null && leagueId !== undefined && callupId !== null && callupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCallup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCallupQueryResult = NonNullable<Awaited<ReturnType<typeof getCallup>>>
export type GetCallupQueryError = ErrorType<void>


/**
 * @summary Get a callup with its signups (members only)
 */

export function useGetCallup<TData = Awaited<ReturnType<typeof getCallup>>, TError = ErrorType<void>>(
 leagueId: string,
    callupId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCallup>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCallupQueryOptions(leagueId,callupId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCallupUrl = (leagueId: string,
    callupId: string,) => {




  return `/api/leagues/${leagueId}/callups/${callupId}`
}

/**
 * @summary Update a callup (admin/owner only)
 */
export const updateCallup = async (leagueId: string,
    callupId: string,
    updateCallupInput: UpdateCallupInput, options?: RequestInit): Promise<CallupSummary> => {

  return customFetch<CallupSummary>(getUpdateCallupUrl(leagueId,callupId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCallupInput)
  }
);}





export const getUpdateCallupMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCallup>>, TError,{leagueId: string;callupId: string;data: BodyType<UpdateCallupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCallup>>, TError,{leagueId: string;callupId: string;data: BodyType<UpdateCallupInput>}, TContext> => {

const mutationKey = ['updateCallup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCallup>>, {leagueId: string;callupId: string;data: BodyType<UpdateCallupInput>}> = (props) => {
          const {leagueId,callupId,data} = props ?? {};

          return  updateCallup(leagueId,callupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCallupMutationResult = NonNullable<Awaited<ReturnType<typeof updateCallup>>>
    export type UpdateCallupMutationBody = BodyType<UpdateCallupInput>
    export type UpdateCallupMutationError = ErrorType<void>

    /**
 * @summary Update a callup (admin/owner only)
 */
export const useUpdateCallup = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCallup>>, TError,{leagueId: string;callupId: string;data: BodyType<UpdateCallupInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCallup>>,
        TError,
        {leagueId: string;callupId: string;data: BodyType<UpdateCallupInput>},
        TContext
      > => {
      return useMutation(getUpdateCallupMutationOptions(options));
    }

export const getDeleteCallupUrl = (leagueId: string,
    callupId: string,) => {




  return `/api/leagues/${leagueId}/callups/${callupId}`
}

/**
 * @summary Delete a callup (admin/owner only)
 */
export const deleteCallup = async (leagueId: string,
    callupId: string, options?: RequestInit): Promise<MessageResult> => {

  return customFetch<MessageResult>(getDeleteCallupUrl(leagueId,callupId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCallupMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCallup>>, TError,{leagueId: string;callupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCallup>>, TError,{leagueId: string;callupId: string}, TContext> => {

const mutationKey = ['deleteCallup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCallup>>, {leagueId: string;callupId: string}> = (props) => {
          const {leagueId,callupId} = props ?? {};

          return  deleteCallup(leagueId,callupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCallupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCallup>>>

    export type DeleteCallupMutationError = ErrorType<void>

    /**
 * @summary Delete a callup (admin/owner only)
 */
export const useDeleteCallup = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCallup>>, TError,{leagueId: string;callupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCallup>>,
        TError,
        {leagueId: string;callupId: string},
        TContext
      > => {
      return useMutation(getDeleteCallupMutationOptions(options));
    }

export const getJoinCallupUrl = (leagueId: string,
    callupId: string,) => {




  return `/api/leagues/${leagueId}/callups/${callupId}/signup`
}

/**
 * @summary Sign up for a callup (members only)
 */
export const joinCallup = async (leagueId: string,
    callupId: string, options?: RequestInit): Promise<CallupSignup> => {

  return customFetch<CallupSignup>(getJoinCallupUrl(leagueId,callupId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getJoinCallupMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinCallup>>, TError,{leagueId: string;callupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof joinCallup>>, TError,{leagueId: string;callupId: string}, TContext> => {

const mutationKey = ['joinCallup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinCallup>>, {leagueId: string;callupId: string}> = (props) => {
          const {leagueId,callupId} = props ?? {};

          return  joinCallup(leagueId,callupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinCallupMutationResult = NonNullable<Awaited<ReturnType<typeof joinCallup>>>

    export type JoinCallupMutationError = ErrorType<void>

    /**
 * @summary Sign up for a callup (members only)
 */
export const useJoinCallup = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinCallup>>, TError,{leagueId: string;callupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof joinCallup>>,
        TError,
        {leagueId: string;callupId: string},
        TContext
      > => {
      return useMutation(getJoinCallupMutationOptions(options));
    }

export const getLeaveCallupUrl = (leagueId: string,
    callupId: string,) => {




  return `/api/leagues/${leagueId}/callups/${callupId}/signup`
}

/**
 * @summary Withdraw from a callup (members only)
 */
export const leaveCallup = async (leagueId: string,
    callupId: string, options?: RequestInit): Promise<MessageResult> => {

  return customFetch<MessageResult>(getLeaveCallupUrl(leagueId,callupId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLeaveCallupMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveCallup>>, TError,{leagueId: string;callupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof leaveCallup>>, TError,{leagueId: string;callupId: string}, TContext> => {

const mutationKey = ['leaveCallup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveCallup>>, {leagueId: string;callupId: string}> = (props) => {
          const {leagueId,callupId} = props ?? {};

          return  leaveCallup(leagueId,callupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveCallupMutationResult = NonNullable<Awaited<ReturnType<typeof leaveCallup>>>

    export type LeaveCallupMutationError = ErrorType<void>

    /**
 * @summary Withdraw from a callup (members only)
 */
export const useLeaveCallup = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveCallup>>, TError,{leagueId: string;callupId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof leaveCallup>>,
        TError,
        {leagueId: string;callupId: string},
        TContext
      > => {
      return useMutation(getLeaveCallupMutationOptions(options));
    }

export const getGetNationalRankingUrl = (params?: GetNationalRankingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/national-ranking?${stringifiedParams}` : `/api/national-ranking`
}

/**
 * @summary Get national ranking for the authenticated user's country
 */
export const getNationalRanking = async (params?: GetNationalRankingParams, options?: RequestInit): Promise<NationalRankingPagedResponse> => {

  return customFetch<NationalRankingPagedResponse>(getGetNationalRankingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNationalRankingQueryKey = (params?: GetNationalRankingParams,) => {
    return [
    `/api/national-ranking`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNationalRankingQueryOptions = <TData = Awaited<ReturnType<typeof getNationalRanking>>, TError = ErrorType<void>>(params?: GetNationalRankingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNationalRanking>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNationalRankingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNationalRanking>>> = ({ signal }) => getNationalRanking(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNationalRanking>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNationalRankingQueryResult = NonNullable<Awaited<ReturnType<typeof getNationalRanking>>>
export type GetNationalRankingQueryError = ErrorType<void>


/**
 * @summary Get national ranking for the authenticated user's country
 */

export function useGetNationalRanking<TData = Awaited<ReturnType<typeof getNationalRanking>>, TError = ErrorType<void>>(
 params?: GetNationalRankingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNationalRanking>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNationalRankingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetNationalRankingStatsUrl = (params?: GetNationalRankingStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/national-ranking/stats?${stringifiedParams}` : `/api/national-ranking/stats`
}

/**
 * @summary Get aggregate stats for the authenticated user's national ranking
 */
export const getNationalRankingStats = async (params?: GetNationalRankingStatsParams, options?: RequestInit): Promise<NationalRankingStats> => {

  return customFetch<NationalRankingStats>(getGetNationalRankingStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNationalRankingStatsQueryKey = (params?: GetNationalRankingStatsParams,) => {
    return [
    `/api/national-ranking/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNationalRankingStatsQueryOptions = <TData = Awaited<ReturnType<typeof getNationalRankingStats>>, TError = ErrorType<void>>(params?: GetNationalRankingStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNationalRankingStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNationalRankingStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNationalRankingStats>>> = ({ signal }) => getNationalRankingStats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNationalRankingStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNationalRankingStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getNationalRankingStats>>>
export type GetNationalRankingStatsQueryError = ErrorType<void>


/**
 * @summary Get aggregate stats for the authenticated user's national ranking
 */

export function useGetNationalRankingStats<TData = Awaited<ReturnType<typeof getNationalRankingStats>>, TError = ErrorType<void>>(
 params?: GetNationalRankingStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNationalRankingStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNationalRankingStatsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteAccountUrl = () => {




  return `/api/account`
}

/**
 * Permanently deletes the caller's personal data (player/club
 * profile, friendships, notifications, achievements, activities,
 * league memberships, level history, push tokens, refresh tokens,
 * callup signups, league join requests) and active sessions.
 * The `users` row itself is preserved with PII scrubbed and
 * `deletedAt` stamped so historical match references render as
 * "Cuenta eliminada". Requires `{ confirm: "ELIMINAR" }` in the
 * body to guard against accidental deletes.
 * @summary Delete the authenticated user's account
 */
export const deleteAccount = async (deleteAccountInput: DeleteAccountInput, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAccountUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deleteAccountInput)
  }
);}





export const getDeleteAccountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{data: BodyType<DeleteAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{data: BodyType<DeleteAccountInput>}, TContext> => {

const mutationKey = ['deleteAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, {data: BodyType<DeleteAccountInput>}> = (props) => {
          const {data} = props ?? {};

          return  deleteAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>
    export type DeleteAccountMutationBody = BodyType<DeleteAccountInput>
    export type DeleteAccountMutationError = ErrorType<void>

    /**
 * @summary Delete the authenticated user's account
 */
export const useDeleteAccount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{data: BodyType<DeleteAccountInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        {data: BodyType<DeleteAccountInput>},
        TContext
      > => {
      return useMutation(getDeleteAccountMutationOptions(options));
    }

export const getAdminCheckUrl = () => {




  return `/api/admin/check`
}

/**
 * @summary Check if the current user is an admin
 */
export const adminCheck = async ( options?: RequestInit): Promise<AdminCheck200> => {

  return customFetch<AdminCheck200>(getAdminCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCheckQueryKey = () => {
    return [
    `/api/admin/check`
    ] as const;
    }


export const getAdminCheckQueryOptions = <TData = Awaited<ReturnType<typeof adminCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCheck>>> = ({ signal }) => adminCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminCheckQueryResult = NonNullable<Awaited<ReturnType<typeof adminCheck>>>
export type AdminCheckQueryError = ErrorType<unknown>


/**
 * @summary Check if the current user is an admin
 */

export function useAdminCheck<TData = Awaited<ReturnType<typeof adminCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminGetStatsUrl = () => {




  return `/api/admin/stats`
}

/**
 * @summary Get basic admin statistics
 */
export const adminGetStats = async ( options?: RequestInit): Promise<AdminStats> => {

  return customFetch<AdminStats>(getAdminGetStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetStatsQueryKey = () => {
    return [
    `/api/admin/stats`
    ] as const;
    }


export const getAdminGetStatsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetStats>>> = ({ signal }) => adminGetStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetStats>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetStatsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetStats>>>
export type AdminGetStatsQueryError = ErrorType<unknown>


/**
 * @summary Get basic admin statistics
 */

export function useAdminGetStats<TData = Awaited<ReturnType<typeof adminGetStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminGetExtendedStatsUrl = () => {




  return `/api/admin/extended-stats`
}

/**
 * @summary Get extended admin statistics
 */
export const adminGetExtendedStats = async ( options?: RequestInit): Promise<ExtendedAdminStats> => {

  return customFetch<ExtendedAdminStats>(getAdminGetExtendedStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetExtendedStatsQueryKey = () => {
    return [
    `/api/admin/extended-stats`
    ] as const;
    }


export const getAdminGetExtendedStatsQueryOptions = <TData = Awaited<ReturnType<typeof adminGetExtendedStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetExtendedStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetExtendedStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetExtendedStats>>> = ({ signal }) => adminGetExtendedStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetExtendedStats>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetExtendedStatsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetExtendedStats>>>
export type AdminGetExtendedStatsQueryError = ErrorType<unknown>


/**
 * @summary Get extended admin statistics
 */

export function useAdminGetExtendedStats<TData = Awaited<ReturnType<typeof adminGetExtendedStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetExtendedStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetExtendedStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminListLeaguesUrl = () => {




  return `/api/admin/leagues`
}

/**
 * @summary List all leagues with member counts (admin only)
 */
export const adminListLeagues = async ( options?: RequestInit): Promise<AdminLeague[]> => {

  return customFetch<AdminLeague[]>(getAdminListLeaguesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListLeaguesQueryKey = () => {
    return [
    `/api/admin/leagues`
    ] as const;
    }


export const getAdminListLeaguesQueryOptions = <TData = Awaited<ReturnType<typeof adminListLeagues>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListLeagues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListLeaguesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListLeagues>>> = ({ signal }) => adminListLeagues({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListLeagues>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListLeaguesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListLeagues>>>
export type AdminListLeaguesQueryError = ErrorType<unknown>


/**
 * @summary List all leagues with member counts (admin only)
 */

export function useAdminListLeagues<TData = Awaited<ReturnType<typeof adminListLeagues>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListLeagues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListLeaguesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminListPendingLeagueMatchesUrl = () => {




  return `/api/admin/matches/league/pending`
}

/**
 * @summary List pending league matches (admin only)
 */
export const adminListPendingLeagueMatches = async ( options?: RequestInit): Promise<PendingLeagueMatch[]> => {

  return customFetch<PendingLeagueMatch[]>(getAdminListPendingLeagueMatchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListPendingLeagueMatchesQueryKey = () => {
    return [
    `/api/admin/matches/league/pending`
    ] as const;
    }


export const getAdminListPendingLeagueMatchesQueryOptions = <TData = Awaited<ReturnType<typeof adminListPendingLeagueMatches>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListPendingLeagueMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListPendingLeagueMatchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListPendingLeagueMatches>>> = ({ signal }) => adminListPendingLeagueMatches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListPendingLeagueMatches>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListPendingLeagueMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListPendingLeagueMatches>>>
export type AdminListPendingLeagueMatchesQueryError = ErrorType<unknown>


/**
 * @summary List pending league matches (admin only)
 */

export function useAdminListPendingLeagueMatches<TData = Awaited<ReturnType<typeof adminListPendingLeagueMatches>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListPendingLeagueMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListPendingLeagueMatchesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminListPendingGlobalMatchesUrl = () => {




  return `/api/admin/matches/global/pending`
}

/**
 * @summary List pending global matches (admin only)
 */
export const adminListPendingGlobalMatches = async ( options?: RequestInit): Promise<AdminMatch[]> => {

  return customFetch<AdminMatch[]>(getAdminListPendingGlobalMatchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListPendingGlobalMatchesQueryKey = () => {
    return [
    `/api/admin/matches/global/pending`
    ] as const;
    }


export const getAdminListPendingGlobalMatchesQueryOptions = <TData = Awaited<ReturnType<typeof adminListPendingGlobalMatches>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListPendingGlobalMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListPendingGlobalMatchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListPendingGlobalMatches>>> = ({ signal }) => adminListPendingGlobalMatches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListPendingGlobalMatches>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListPendingGlobalMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListPendingGlobalMatches>>>
export type AdminListPendingGlobalMatchesQueryError = ErrorType<unknown>


/**
 * @summary List pending global matches (admin only)
 */

export function useAdminListPendingGlobalMatches<TData = Awaited<ReturnType<typeof adminListPendingGlobalMatches>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListPendingGlobalMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListPendingGlobalMatchesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminListAllMatchesUrl = (params?: AdminListAllMatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/matches/all?${stringifiedParams}` : `/api/admin/matches/all`
}

/**
 * @summary List all matches with optional status and type filters (admin only)
 */
export const adminListAllMatches = async (params?: AdminListAllMatchesParams, options?: RequestInit): Promise<AdminMatch[]> => {

  return customFetch<AdminMatch[]>(getAdminListAllMatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListAllMatchesQueryKey = (params?: AdminListAllMatchesParams,) => {
    return [
    `/api/admin/matches/all`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListAllMatchesQueryOptions = <TData = Awaited<ReturnType<typeof adminListAllMatches>>, TError = ErrorType<unknown>>(params?: AdminListAllMatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListAllMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListAllMatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListAllMatches>>> = ({ signal }) => adminListAllMatches(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListAllMatches>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListAllMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListAllMatches>>>
export type AdminListAllMatchesQueryError = ErrorType<unknown>


/**
 * @summary List all matches with optional status and type filters (admin only)
 */

export function useAdminListAllMatches<TData = Awaited<ReturnType<typeof adminListAllMatches>>, TError = ErrorType<unknown>>(
 params?: AdminListAllMatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListAllMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListAllMatchesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminListPendingScheduledMatchesUrl = () => {




  return `/api/admin/scheduled-matches/pending`
}

/**
 * @summary List all scheduled matches in score_submitted state across all leagues (admin only)
 */
export const adminListPendingScheduledMatches = async ( options?: RequestInit): Promise<AdminPendingScheduledMatch[]> => {

  return customFetch<AdminPendingScheduledMatch[]>(getAdminListPendingScheduledMatchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListPendingScheduledMatchesQueryKey = () => {
    return [
    `/api/admin/scheduled-matches/pending`
    ] as const;
    }


export const getAdminListPendingScheduledMatchesQueryOptions = <TData = Awaited<ReturnType<typeof adminListPendingScheduledMatches>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListPendingScheduledMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListPendingScheduledMatchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListPendingScheduledMatches>>> = ({ signal }) => adminListPendingScheduledMatches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListPendingScheduledMatches>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListPendingScheduledMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListPendingScheduledMatches>>>
export type AdminListPendingScheduledMatchesQueryError = ErrorType<unknown>


/**
 * @summary List all scheduled matches in score_submitted state across all leagues (admin only)
 */

export function useAdminListPendingScheduledMatches<TData = Awaited<ReturnType<typeof adminListPendingScheduledMatches>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListPendingScheduledMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListPendingScheduledMatchesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminListClubsUrl = (params?: AdminListClubsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/clubs?${stringifiedParams}` : `/api/admin/clubs`
}

/**
 * @summary List clubs for admin (with verified filter)
 */
export const adminListClubs = async (params?: AdminListClubsParams, options?: RequestInit): Promise<Club[]> => {

  return customFetch<Club[]>(getAdminListClubsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListClubsQueryKey = (params?: AdminListClubsParams,) => {
    return [
    `/api/admin/clubs`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListClubsQueryOptions = <TData = Awaited<ReturnType<typeof adminListClubs>>, TError = ErrorType<unknown>>(params?: AdminListClubsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListClubs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListClubsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListClubs>>> = ({ signal }) => adminListClubs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListClubs>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListClubsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListClubs>>>
export type AdminListClubsQueryError = ErrorType<unknown>


/**
 * @summary List clubs for admin (with verified filter)
 */

export function useAdminListClubs<TData = Awaited<ReturnType<typeof adminListClubs>>, TError = ErrorType<unknown>>(
 params?: AdminListClubsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListClubs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListClubsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminUpdateClubUrl = (id: string,) => {




  return `/api/admin/clubs/${id}`
}

/**
 * @summary Update club (name, city, country, verified)
 */
export const adminUpdateClub = async (id: string,
    updateClubInput: UpdateClubInput, options?: RequestInit): Promise<Club> => {

  return customFetch<Club>(getAdminUpdateClubUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateClubInput)
  }
);}





export const getAdminUpdateClubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateClub>>, TError,{id: string;data: BodyType<UpdateClubInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdateClub>>, TError,{id: string;data: BodyType<UpdateClubInput>}, TContext> => {

const mutationKey = ['adminUpdateClub'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateClub>>, {id: string;data: BodyType<UpdateClubInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdateClub(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateClubMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateClub>>>
    export type AdminUpdateClubMutationBody = BodyType<UpdateClubInput>
    export type AdminUpdateClubMutationError = ErrorType<unknown>

    /**
 * @summary Update club (name, city, country, verified)
 */
export const useAdminUpdateClub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateClub>>, TError,{id: string;data: BodyType<UpdateClubInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdateClub>>,
        TError,
        {id: string;data: BodyType<UpdateClubInput>},
        TContext
      > => {
      return useMutation(getAdminUpdateClubMutationOptions(options));
    }

export const getAdminDeleteClubUrl = (id: string,) => {




  return `/api/admin/clubs/${id}`
}

/**
 * @summary Delete a club
 */
export const adminDeleteClub = async (id: string, options?: RequestInit): Promise<SuccessResult> => {

  return customFetch<SuccessResult>(getAdminDeleteClubUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteClubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteClub>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteClub>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminDeleteClub'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteClub>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteClub(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteClubMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteClub>>>

    export type AdminDeleteClubMutationError = ErrorType<unknown>

    /**
 * @summary Delete a club
 */
export const useAdminDeleteClub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteClub>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminDeleteClub>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAdminDeleteClubMutationOptions(options));
    }

export const getAdminMergeClubUrl = (id: string,) => {




  return `/api/admin/clubs/${id}/merge`
}

/**
 * @summary Merge a club into a target. Redirects all FK references to the target and deletes the source.
 */
export const adminMergeClub = async (id: string,
    mergeClubInput: MergeClubInput, options?: RequestInit): Promise<Club> => {

  return customFetch<Club>(getAdminMergeClubUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mergeClubInput)
  }
);}





export const getAdminMergeClubMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMergeClub>>, TError,{id: string;data: BodyType<MergeClubInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMergeClub>>, TError,{id: string;data: BodyType<MergeClubInput>}, TContext> => {

const mutationKey = ['adminMergeClub'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMergeClub>>, {id: string;data: BodyType<MergeClubInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  adminMergeClub(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMergeClubMutationResult = NonNullable<Awaited<ReturnType<typeof adminMergeClub>>>
    export type AdminMergeClubMutationBody = BodyType<MergeClubInput>
    export type AdminMergeClubMutationError = ErrorType<unknown>

    /**
 * @summary Merge a club into a target. Redirects all FK references to the target and deletes the source.
 */
export const useAdminMergeClub = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMergeClub>>, TError,{id: string;data: BodyType<MergeClubInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminMergeClub>>,
        TError,
        {id: string;data: BodyType<MergeClubInput>},
        TContext
      > => {
      return useMutation(getAdminMergeClubMutationOptions(options));
    }

